import { PropsWithChildren } from 'react';

import { AffixProps } from '@mantine/core';

import { Affix } from '../Affix';

interface ModalAffixedFooterProps extends AffixProps, PropsWithChildren {}

const ModalAffixedFooter = ({ children, ...props }: ModalAffixedFooterProps) => {
  return (
    <Affix
      withinPortal={false}
      pos="sticky"
      p="lg"
      mt="xs"
      m={-24}
      bg="linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 35.23%)"
      {...props}
    >
      {children}
    </Affix>
  );
};

export { ModalAffixedFooter };
export type { ModalAffixedFooterProps };
